export default {
  softwareName: '软件名称',
  softwareType: '软件类型',
  md5: '数量',
  orgId: '组织ID',
  softwareListSeach: '搜索软件名称',
  addSoftwareDictionary: '新增软件字典',
  edit: '编辑',
  del: '删除',
  package: '安装包',
  soft: '软件',
  matchType: '匹配类型',
  type_not_empty: '匹配类型不能为空',
  name_not_empty: '软件名称不能为空',
  syncToTerminal: '同步软件字典至终端分组',
  firstCreateTime: '首次创建时间',
  createTime: '创建时间',
  name_length_limit: '软件名称需至少2个字符'
}